// extracted by mini-css-extract-plugin
module.exports = {"AboutPage":"AboutPage_AboutPage__hUy8W","card":"AboutPage_card__4E5X7","wrapper":"AboutPage_wrapper__13RAH","title":"AboutPage_title__b1JEu","content":"AboutPage_content__3xxBP"};